import {NetworkError} from 'apstra-ui-common';
import {castArray, includes} from 'lodash';

// TODO: move to apstra-ui-common

export const allowResponseErrorCode = async <T>(
  requestResult: Promise<T>,
  allowedCodes: number | number[]
): Promise<T | null> => {
  try {
    return await requestResult;
  } catch (error) {
    if (error instanceof NetworkError &&
      includes(castArray(allowedCodes), error.response?.status)) {
      return null;
    }
    throw error;
  }
};
